export enum Role {
  InvestorClassified = 'INVESTOR_CLASSIFIED',
  InvestorVerified = 'INVESTOR_VERIFIED',
  Admin = 'ADMIN',
}
